import(/* webpackMode: "eager" */ "/app/app/faq/page.jsx");
